import ENDPOINT from "@/api/endpoints";
import { HTTP, buildQueries, HTTP_FILE } from "@/api/http-common";
import _cloneDeep from "lodash/cloneDeep";
import { formatAttachFilesData } from "@/utils/uploadFileUtils";

const formDataHeaderConfig = {
  headers: {
    "Content-Type": "multipart/form-data;",
  },
};

function getFormDataFromPayload(payload) {
  let formData = new FormData();
  for (let key in payload) {
    if (["NhiemVuXuLy"].indexOf(key) === -1) {
      formData.append(key, payload[key]);
    }
  }
  const NhiemVuXuLy = _cloneDeep(payload.NhiemVuXuLy);

  NhiemVuXuLy.forEach((file, index) => {
    formData = formatAttachFilesData(file, index, formData, "NhiemVuXuLy");
  });

  return formData;
}

export function callApiGetNhiemVuPaging(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.GET_NHIEM_VU_PAGING}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetLoaiNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.NHIEM_VU.GET_LOAI_NHIEM_VU}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function callApiGetTatCaLoaiNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.NHIEM_VU.GET_TAT_CA_LOAI_NHIEM_VU}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.TAO_MOI,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiTaoVanBanLienQuan(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.THEM_MOI_VAN_VAN_BAN_LIEN_QUAN,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiUploadFile(payload) {
  const formData = getFormDataFromPayload(payload);
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.NHIEM_VU.THEM_MOI_FILE,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiUploadOneFile(payload) {
  const formData = getFormDataFromPayload(payload);
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.NHIEM_VU.THEM_MOI_ONE_FILE,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiThemMoiYKien(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.THEM_MOI_Y_KIEN_XU_LY,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayDanhSachNguoiGiaoNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_NGUOI_GIAO_NV}${payload}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiCapNhatNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.CAP_NHAT_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiCapNhatVanBanLienQuanNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.CAP_NHAP_VAN_BAN_LIEN_QUAN_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiCapNhatYKienXuLyNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.CAP_NHAP_Y_KIEN_XU_LY_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayChiTietNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.CHI_TIET_NHIEM_VU}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayChiTietVanBanLienQuan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.CHI_TIET_VAN_BAN_LIEN_QUAN}${payload.nhiemVuId}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayChiTietYKienXuLy(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.CHI_TIET_Y_KIEN_XU_LY}${payload.nhiemVuId}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetTatCaDonViTrongDonViCha(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.GET_TAT_CA_DON_VI_TRONG_DON_VI_CHA}?${buildQueries(
        payload
      )}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetTatCaCanBoCoQuyenPhanXuLy(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.GET_TAT_CAT_CAN_BO_CO_QUYEN_PHAN_XU_LY_TRONG_DON_VI
      }${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetTatCaCanBoTrongDonVi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.GET_TAT_CAT_CAN_BO_TRONG_DON_VI}${payload.idCanBo}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiXoaNhomChucVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.NHIEM_VU.NHOM_NHIEM_VU_XOA}${payload.Id}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiThemYKienNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.THEM_Y_KIEN_XU_LY,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiThuHoiNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.THU_HOI_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayDanhSachThuHoiNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_THU_HOI_NHIEM_VU}${payload.id}&taskId=${payload.taskId}&taskType=`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function callApiLayDanhSachThuHoiCongViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
        `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_THU_HOI_NHIEM_VU}${payload.id}&taskId=${payload.taskId}&taskType=${payload.taskType}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTraLaiNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.TRA_LAI_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayDanhSachTraLaiNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_TRA_LAI_NHIEM_VU}?${buildQueries(
        payload
      )}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDonDocNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.DON_DOC_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiCapNhatTinhHinhNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.CAP_NHAT_TINH_HINH_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayDanhSachSoLuongNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.NHIEM_VU.SO_LUONG_NHIEM_VU}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.DANH_SACH_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetTrangThai() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.NHIEM_VU.DANH_SACH_TRANG_THAI)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDonViCaNhan() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.NHIEM_VU.GET_DON_VI_CA_NHAN)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiCapNhatTuDongHoanThanh(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.CAP_NHAT_TU_DONG_HOAN_THANH,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiPhanXuLy(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.PHAN_XU_LY,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiUpdatePhanXuLy(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.UPDATE_PHAN_XU_LY,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetPhanXuLyByNhiemVuId(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.NHIEM_VU.GET_PHAN_XU_LY_BY_NHIEM_VU_ID + payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDonViXuLyES(payload) {
  return new Promise((resolve, reject) => {
    if (payload) {
      return HTTP.get(
        `${ENDPOINT.NHIEM_VU.GET_PHAN_DON_VI_XI_LY_ES}?${buildQueries(payload)}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      return HTTP.get(ENDPOINT.NHIEM_VU.GET_PHAN_DON_VI_XI_LY_ES)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }
  });
}

export function callApiGetDonViXuLy(payload) {
  return new Promise((resolve, reject) => {
    if (payload) {
      return HTTP.get(
        `${ENDPOINT.NHIEM_VU.GET_PHAN_DON_VI_XU_LY}?${buildQueries(payload)}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      return HTTP.get(ENDPOINT.NHIEM_VU.GET_PHAN_DON_VI_XU_LY)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }
  });
}

export function callApiGetDonViXuLyMulti(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      payload ? `${ENDPOINT.VAN_BAN_DEN.PHAN_XU_LY_NHIEU}?${buildQueries(payload)}` : ENDPOINT.VAN_BAN_DEN.PHAN_XU_LY_NHIEU
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDonViXuLyChildren2(payload) {
  return new Promise((resolve, reject) => {
    if (payload) {
      return HTTP.get(
        `${ENDPOINT.NHIEM_VU.GET_PHAN_DON_VI_XU_LY_CHILDREN}?${buildQueries(payload)}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      return HTTP.get(ENDPOINT.NHIEM_VU.GET_PHAN_DON_VI_XU_LY_CHILDREN)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }
  });
}

export function callApiGetDonViXuLyNew(payload) {
  return new Promise((resolve, reject) => {
    if (payload) {
      return HTTP.get(
        `http://10.0.0.57:1311/api/qlnv/phan-xu-ly/get-all-don-vi?${buildQueries(payload)}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      return HTTP.get('http://10.0.0.57:1311/api/qlnv/phan-xu-ly/get-all-don-vi')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }
  });
}

export function callApiGetLichSuPhanXuLy(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_LICH_SU_PHAN_SU_LY}${payload}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayTrangThaiTinhHinhThucHien() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.NHIEM_VU.LAY_TRANG_THAI_TINH_HINH_THUC_HIEN)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayTrangThaiChoDuyetHoanThanh() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.NHIEM_VU.LAY_TRANG_THAI_CHO_DUYET_HOAN_THANH)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiThemMoiTinhHinhThucHien(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.THEM_MOI_TINH_HINH_THUC_HIEN,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiCapNhatVBLQTinhHinhThucHien(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.CAP_NHAT_VBLQ_TINH_HINH_THUC_HIEN,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiThemVBLQTinhHinhThucHien(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.THEM_VBLQ_TINH_HINH_THUC_HIEN,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayTinhHinhThucHienNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_TINH_HINH_THUC_HIEN_NHIEM_VU}?${buildQueries(
        payload
      )}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayTinhHinhThucHienCongViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_TINH_HINH_THUC_HIEN_CONG_VIEC}?${buildQueries(
        payload
      )}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayPhuongThucNhanNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      ENDPOINT.NHIEM_VU.LAY_DANH_SACH_PHUONG_THUC_NHAN_NHIEM_VU,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuTraLaiNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_LICH_SU_TRA_LAI}${payload.Id}/${payload.TaskId}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuCapNhatTinhHinhNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_LICH_SU_CAP_NHAT_TINH_HINH}${payload.Id}/${payload.TaskId}?tab=${payload.tab}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuVPCPDonDoc(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_LICH_SU_VPCP_DON_DOC}${payload.Id}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuVPCPTienDo(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_TIEN_DO_VPCP}${payload.Id}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuVPCPDieuChinh(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_DIEU_CHINH_VPCP}${payload.Id}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuGuiTraVPCP(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_LICH_SU_GUI_TRA_VPCP}${payload.Id}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuThuHoiNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_LICH_SU_THU_HOI}${payload.Id}&taskId=${payload.TaskId}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuDonDocNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_LICH_SU_DON_DOC}${payload.Id}&taskId=${payload.TaskId}&taskType=`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuDonDocCongViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
        `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_LICH_SU_DON_DOC}${payload.Id}&taskId=${payload.TaskId}&TaskType=${payload.TaskType}`
    )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
}

export function callApiTraLaiNhiemVuVPCP(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.TRA_LAI_NHIEM_VU_CHINH_PHU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayDanhSachDemLoaiNhiemVuCaNhan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_DEM_LOAI_NHIEM_VU_CA_NHAN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachDemLoaiNhiemVuDonVi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_DEM_LOAI_NHIEM_VU_DON_VI}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachDemLoaiCongViec() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.NHIEM_VU.LAY_DANH_SACH_DEM_LOAI_CONG_VIEC)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachSoDoLuongNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_SO_DO_LUONG_NHIEM_VU}${payload}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachSoDoLuongNhiemVuV2(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
        `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_SO_DO_LUONG_NHIEM_VU_V2}${payload.Id}&taskId=${payload.TaskId}`
    )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
}

export function callApiLayDanhSachSoDoLuongNhiemVuToken(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.LAY_DANH_SACH_SO_DO_LUONG_NHIEM_VU}${payload.processId}&token=${payload.token}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachDemLoaiCongViecDonVi() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.NHIEM_VU.LAY_DANH_SACH_DEM_LOAI_CONG_VIEC_DON_VI)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachDemLoaiCongViecDV() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.NHIEM_VU.LAY_DANH_SACH_DEM_LOAI_CONG_VIEC_DV)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetExportNhiemVu(payload) {
  return HTTP_FILE({
    url: ENDPOINT.NHIEM_VU.GET_EXPORT_FILE,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiDownloadFileExport(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.get(
      `${ENDPOINT.NHIEM_VU.DOWNLOAD_FILE_EXPORT}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDanhSachNhiemVuFromImportFile(payload) {
  const formData = getFormDataFromPayload(payload);
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.NHIEM_VU.GET_DANH_SACH_NHIEM_VU_FROM_IMPORT_FILE,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiKiemThuFileImportNhiemVu(payload) {
  return HTTP_FILE({
    url: ENDPOINT.NHIEM_VU.KIEM_THU_IMPORT_FILE,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiImportNhiemVu(payload) {
  return HTTP_FILE({
    url: ENDPOINT.NHIEM_VU.IMPORT_FILE,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXoaNhiemVu(payload) {
  return HTTP({
    url: `${ENDPOINT.NHIEM_VU.XOA_NHIEM_VU}/${payload.Id}/${payload.taskId}`,
    method: "POST",
    asyncLoading: true,
  });
}

export function callApiGetCotNhiemVuExport() {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.NHIEM_VU.GET_COT_NHIEM_VU_EXPORT}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDanhSachNhiemVuExportTemplate() {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.NHIEM_VU.GET_NHIEM_VU_EXPORT_TEMPLATE}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiThemMoiExportTemplate(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.THEM_MOI_EXPORT_TEMPLATE,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGuiLaiVPCPNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.GUI_LAI_VPCP_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayDanhSachPhamVi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.LAY_DANH_SACH_PHAM_VI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiSuaYKienNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.SUA_Y_KIEN_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXoaYKienNhiemVu(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.XOA_Y_KIEN_NHIEM_VU,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetTaskPhanXuLyId(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.NHIEM_VU.GET_TASK_PHAN_XU_LY_ID}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDanhSachDonViNhiemVuPhanXuLy(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.DS_DONVI_DA_PHAN_XU_LY,
    method: "GET",
    params: payload,
  });
}

export function callApiTraLaiCongViec(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.TRA_LAI_CONG_VIEC,
    method: "GET",
    params: payload,
  });
}

export function callApiYeuCauGiaHanVPCP(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.YEU_CAU_GIA_HAN_VPCP,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiUpdateVanBanLienQuan(payload) {
  return HTTP({
    url: ENDPOINT.NHIEM_VU.UPDATE_VAN_BAN_LQ,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}
